// extracted by mini-css-extract-plugin
export default {"actionsMenu":"FlowRunsActionsMenu_actionsMenu__2ZADY"};